import React, { useEffect }  from 'react';
import { LoadingText } from '../../components/Loading';
import Image from '../../components/Image';
import PageInfo from '../../components/PageInfo';
import YTEmbed from '../../components/YTEmbed';
import {
  Link
} from "react-router-dom";

export function RenderMod(props) {
  PageInfo(props);
  const mod = props.mod;
  const available = mod.early || mod.url || (mod.downloads && Object.keys(mod.downloads).length > 0);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="text-align-center">

      <div className="title-section">
        {mod.name}
      </div>
      <div className="subtitle-section">
        {"Grand Theft Auto V Mod"}
      </div>

      <div className="mod-details">
        
        {/* MOD INFORMATION */}

        <div className="mod-details-left">

          <div className={available ? "mod-details-section" : "mod-details-section-large"}>

            <div className="width-1024">
              {mod.info ? <div className="text-align-center">
                {mod.info.map((i, ind) => {
                  if (i.type === "subtitle")
                  {
                    return (
                      <div key={ind} className="subtitle-section">
                        {i.text}
                      </div>
                    )
                  } else if (i.type === "image") {
                    return (
                      <div key={ind} className="text-section">
                        {Image(i.src, i.text, undefined, undefined, i.width || "100%")}
                      </div>
                    )
                  } else if (i.type === "text") {
                    return (
                      <div key={ind} className="text-section">
                        {i.text}
                      </div>
                    )
                  } else if (i.type === "hr") {
                    return (
                      <hr key={ind}/>
                    )
                  } else if (i.type === "support") {
                    return (
                      <div key={ind} className="col-buttons mod-buttons-early">
                        <div className="mod-button mod-button-patreon text-align-center"><a href="https://patreon.com/SilverFinish" target="_blank" rel="noreferrer">Patreon</a></div>
                        <div className="mod-button mod-button-youtube text-align-center"><a href="https://www.youtube.com/@SilverFinish/join" target="_blank" rel="noreferrer">YouTube</a></div>
                      </div>
                    )
                  } else if (i.type === "development") {
                    return (
                      <div key={ind} className="col-buttons mod-buttons-early">
                        <div className="mod-button mod-button-discord text-align-center"><a href="https://discord.com/invite/QbhWpsX" target="_blank" rel="noreferrer">Discord</a></div>
                      </div>
                    )
                  }
                  return null;
                })}
              </div> : null}
              {mod.desc ? <div className="text-section">
                { mod.desc }
              </div> : null}
              {available ? <div>
                <div className="subtitle-section">Requirements</div>
                <ul>
                  <li><a href="http://www.dev-c.com/gtav/scripthookv" target="_blank" rel="noreferrer">ScriptHookV</a></li>
                  <li><a href="https://github.com/scripthookvdotnet/scripthookvdotnet/releases" target="_blank" rel="noreferrer">ScriptHookVDotNet</a><div className="sf-text sf-version">⚠️ Use <a href="https://github.com/scripthookvdotnet/scripthookvdotnet-nightly/releases" target="_blank" rel="noreferrer">nightly builds</a> for newer Legacy versions, no support for Enhanced until <a href="https://github.com/scripthookvdotnet/scripthookvdotnet/issues/1558" target="_blank" rel="noreferrer">updated</a>.</div></li>
                  { mod.requiresSftools ? <li>SFCore (Included)</li> : null }
                </ul>
              </div> : null}
              { mod.ytUrl ?
                <div className="width-1024">
                  <div className="subtitle-section">Video</div>
                  <div>{mod.ytUrl ? YTEmbed({ytUrl: mod.ytUrl, openConsent: props.openConsent}) : null}</div>
                </div>
              : null }
            </div>

          </div>

        </div>

        {available ? <div className="mod-details-right">

          {/* EARLY ACCESS */}

          {mod.early ? <div className="mod-details-section">
            <div className="subtitle-section">{`${mod.early.version} Early Access`}</div>
            <div className="text-section">
              <div className="mod-patch-early-detail">{mod.early.detail}</div>
            </div>
            <div className="col-buttons mod-buttons-early">
              {mod.early.patreon ? <div className="mod-button mod-button-patreon text-align-center"><a href={mod.early.patreon} target="_blank" rel="noreferrer">Patreon</a></div> : null}
              {mod.early.youtube ? <div className="mod-button mod-button-youtube text-align-center"><a href={mod.early.youtube} target="_blank" rel="noreferrer">YouTube</a></div> : null}
            </div>
          </div> : null}

          {/* DOWNLOADS */}

          {mod.url || (mod.downloads && mod.downloads.length > 0) || mod.early == null ? <div className="mod-details-section">

            <div className="subtitle-section">Downloads</div>

              <div>
                {(mod.downloads && mod.downloads.length > 0) ? [...mod.downloads].reverse().map((d) => {
                  return (
                    <div key={d}>
                      <div className="mod-button text-align-center"><a href={`/download?id=${d}`} download>Download {mod.files[d].version}</a></div>

                      <div className="downloads-bar">
                        <div className="stats-item"><img src={`/icons/download16.webp`} alt="Download Icon" />{LoadingText(props.stats?.mods?.downloads[mod.src].files[d])} downloads</div>
                      </div>

                      <div className="mod-checksum">MD5: {mod.files[d].md5}</div>

                      <hr/>
                    </div>
                  )
                }) : null}

                {mod.url ? 
                  <div>
                    <div className="mod-button text-align-center">
                      <a href={mod.url} target="_blank" rel="noreferrer">5Mods Page</a>
                    </div>
                    <div className="mod-version">Latest Version: {mod.version}</div>
                  </div>
                : null}

                { !(mod.url || mod.downloads) ? <div className="mod-button-disabled text-align-center">Coming Soon</div> : null }

                { mod.url || mod.downloads ? <a href="/guides/install-gta-5-script-mods#scripthookvdotnet" target="_blank" rel="noreferrer">Installation Guide</a> : null }

            </div>

          </div> : null}

          {/* PATCH NOTES */}

          {mod.patches ? <div className="mod-details-section">

            <div className="subtitle-section">Patch Notes</div>

            {Object.keys(mod.patches).reverse().map((p, i) => {
              return (
                <div key={p}>
                  <div className="text-section">
                    <div className="mod-patch underline">{p.replace(/-/g, '.')}</div>
                    <div className="mod-date">{new Date(mod.patches[p].time).toLocaleDateString()}</div>
                    <div className="mod-patch-detail">{mod.patches[p].detail}</div>
                    {i !== Object.keys(mod.patches).length - 1 ? <hr/> : null}
                  </div>
                </div>
              )
            })}

          </div> : null}
            
        </div> : null}

      </div>

      { mod.download && !mod.url ?
        <div className="margin-top padding-16">
          SilverFinish.net is the only official source for this mod - redistribution is not permitted
        </div>
      : null }
    </div>
  );
}

function Mods(props) {
  PageInfo(props);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="text-align-center">

      <div className="page-banner">
        {Image(`/images/banner-mods.webp`, "Mods")}
      </div>

      <div className="stats-bar">
        {(props.stats?.mods) ? <div className="stats-item" style={{display: "flex"}}><div style={{width: "12px", height: "12px", marginRight: "4px"}}>{Image(`/icons/download16.webp`, "Download Icon")}</div>Total Downloads: {props.stats?.mods?.totalDownloads}</div> : null}
      </div>

      <div className="title-section">
        Grand Theft Auto V Mods
      </div>

      <div className="page-content">
        <div className="cards">
          {Object.values(props.mods).sort((a, b) => (a.time < b.time)).map((m) => {
            return (
              <div className="cards-item" key={`${m.name}`} style={{width: "100%"}}>
                <Link to={`/mods/${m.src}`}>
                  {Image(`/mods/images/${m.src}.webp`, m.name)}
                  <div className="card-overlay">{m.name}</div>
                  {m.dev ? <img className="card-icon" src="/icons/dev.webp" alt="In Development" title="In Development"></img> : null}
                  {m.early != null && (!m.downloads || m.downloads.length <= 0) ? <img className="card-icon" src="/icons/ea.webp" alt="Early Access" title="Early Access"></img> : null}
                </Link>
              </div>
            )})}
        </div>
      </div>

    </div>
  );
}

export default Mods;